import { useHistory } from "react-router-dom";

import axios from "axios";
import { displayFlagByCountryCode, getValueByKey } from "../../Utils/utils";
import React, { useState, useEffect } from "react";


function ComposersPagePreviewCard({ composer, userData }) {
  let history = useHistory();
  const [artisttype, setArtisttype] = useState([]);
  const userLang = userData?.language || 'de';

  useEffect(() => {
    let isMounted = true; 
    const lang = userData?.language || "de";
    axios.get(`/settings/options?type=artisttype&lang=${lang}`)
      .then(res => { if (res.data && isMounted) setArtisttype(res.data); })
      .catch(err => console.error("Fehler beim Laden der Kategorien:", err));
	return () => { isMounted = false; };
  }, [userData]);  

  return (
    <li
      key={composer.name}
      className="li-height"
      onClick={() => history.push(`/composer/${composer.safe_name}`)}
    >
      <div className="box-container remove_shadow">
        <img className="thumbnail-image" 
		    src={`${axios.defaults.baseURL}${composer.portraitUrl}`}
			alt="portrait" 
		/>
        <div className="comp-name-container">
          <span className="comp-name">{composer.name}</span>
        </div>
        <div className="life-container">
          <span className="life-text">{composer.disambiguation}<br/>
		  <span className="text-highlight">{getValueByKey(artisttype, composer.type, userLang, "artisttype")} <br/></span>
          {displayFlagByCountryCode(composer.countryCode)} {composer.countryCode}<br/><br/></span>
        </div>
      </div>
    </li>
  );
}

export default ComposersPagePreviewCard;